export enum EventCategory {
	OTHER = 'OTHER',
	OSKAR = 'OSKAR',
	OSKAR_PLANE = 'OSKAR_PLANE',
	ENSILAGE = 'ENSILAGE',
	SERVICE = 'SERVICE',
	RENT = 'RENT',
	GROUP = 'GROUP',
	FOREIGN = 'FOREIGN LDC',
	FOREIGN_SCANDINAVIA = 'FOREIGN_SCANDINAVIA',
	FLEET = 'FLEET',
	TECHNICAL_EMPTY = 'TECHNICAL_EMPTY',
	WASH = 'WASH',
	ANTENNA_BUS = 'ANTENNA_BUS',
	MALFUNCTION = 'MALFUNCTION',
}

export type EventLabel = {
	[k in keyof typeof EventCategory]: string;
};

export const EventCategoryLabel: EventLabel = {
	OTHER: 'Inne',
	OSKAR: 'Oskar',
	OSKAR_PLANE: 'Oskar Samolot',
	ENSILAGE: 'Postój',
	SERVICE: 'Serwis',
	RENT: 'Wynajem',
	GROUP: 'Wynajem Grupa',
	FOREIGN: 'Wynajem LDC',
	FOREIGN_SCANDINAVIA: 'Wynajem LDC Skandynawia',
	FLEET: 'Flota',
	TECHNICAL_EMPTY: 'Przejazd techniczny na pusto',
	WASH: 'Myjnia',
	ANTENNA_BUS: 'Antenka autokar',
	MALFUNCTION: 'Awaria',
};
